import React, { useEffect, useState } from "react";
import { CIcon } from '@coreui/icons-react';
import {  cilLocationPin, cilPhone } from '@coreui/icons';
import { collection, doc, getDoc, getDocs, onSnapshot, query, where } from "firebase/firestore";
import db from "../../firebase/firebaseConfig";
import { useNavigate, useParams } from "react-router-dom";
import { ref, getDownloadURL } from "firebase/storage";
import { storage } from "../../firebase/firebaseConfig"
import { useAuth } from "../../contexts/authContext";
import { useLoading } from "../Loading";
// import { getPetDetails, getPetImage } from "../utils/api";

function PetDetails() {
    const navigate = useNavigate();
    const { id } = useParams()
    const [pets, setPets] = useState({});
    const [shelter, setShelterData] = useState({});
    const [imageUrls, setImageUrls] = useState("/blue.gif");
    const {setLoading} = useLoading();

    useEffect(() => {
        if (!id) {
            navigate("/adopt");
        }
        const fetchPets = async () => {
            const petId = id;
            const petCollection = doc(db, "Pets", petId);

            const unsubscribePetDetails = onSnapshot(petCollection, (petSnapshot)=>{
                if (petSnapshot.exists()&&petSnapshot.data().status!=="Adopted") {
                    const petList = { id: petId, ...petSnapshot.data() };
                    setPets(petList);
                   
                }
                else{
                    navigate("/adopt");
                }
            }, (error)=>{
                console.error(error);
            });
            return ()=>unsubscribePetDetails();
            
        };

        fetchPets();
    }, [id, navigate]);


    useEffect(() => {
        const fetchShelter = async () => {
            if (!pets.shelterId) return;
            const shelterId = pets.shelterId;
            const shelterCollection = doc(db, "Shelters", shelterId);
            const shelterSnapshot = await getDoc(shelterCollection);
            if (shelterSnapshot.exists()) {
                const shelterDetials = { id: shelterId, 
                    shelterName:shelterSnapshot.data().shelterName,
                    address:shelterSnapshot.data().address, 
                    phoneNumber:shelterSnapshot.data().phoneNumber, };
                setShelterData(shelterDetials);
            }
            setLoading(false);
        };

        fetchShelter();
        
    }, [pets.shelterId]);

   

    useEffect(() => {
        const fetchImages = async () => {
            if (!pets.image) return;
            try {
                const imageRef = ref(storage, `AdoptPets/${pets.image}`);
                const url = await getDownloadURL(imageRef);
                setImageUrls(url);

            } catch (error) {
                console.error(error);
                setImageUrls("/blue.gif");  // Fallback image
            }

        };

        fetchImages();

    }, [pets.image, pets.id]);

    const { currentUser} = useAuth();
    const adoptBtn = async() => {
        if (!currentUser) {
            navigate('/login');
        }
        else {
            // const applicationRef = doc(db, "Applications", `${currentUser.uid}_${pets.id}`);
            const applicationRef = query(collection(db, "Applications"), where("adopterId", "==", currentUser.uid), where("petId", "==", pets.id));

            const applicationSnap = await getDocs(applicationRef);
            let hasPendingOrApproved = false;
            const promises = applicationSnap.docs.map(async (applicationDoc) => {
                const applicationData = applicationDoc.data();
    
                if (applicationData.status === "Approved") {
                    const appointmentRef = doc(db, "Appointments", applicationDoc.id);
                    const appointmentSnap = await getDoc(appointmentRef);
                    if (appointmentSnap.exists() && appointmentSnap.data().status !== "Rejected") {
                        return true; // Return true if approved and appointment exists
                    }
                    else if(!appointmentSnap.exists())
                    {
                        return true;
                    }
                } else if (applicationData.status === "Pending") {
                    return true; // Return true if pending
                }
                return false;
            });

            const results = await Promise.all(promises);

            hasPendingOrApproved = results.some(result => result);

            if (hasPendingOrApproved) {
                alert("You have already applied for this pet");
                return;
            }
            else{
                navigate(`/application-form/${pets.id}`, { state: { root: true } })
            }
           
        }
    }

    return (
        <div className="petDetailsContainer">
        <div className="detailCard" >
            <div className="row g-0">
                <div className="col-md-6">
                    <img src={imageUrls} className="img-fluid" alt="..." />

                </div>
                <div className="col-md-6">
                    <div className="card-body">
                        <h4 className="cardTitle">{pets.petName}</h4>
                        <p className="card-text">{pets.breed}</p>
                        <div className="petDetailsList">
                            <table>
                                <tbody>
                                    <tr className="detail-row">
                                        <td className="detailLabel">Location:</td>
                                        <td className="detailValue">{pets.location || "Unknown"}</td>
                                    </tr>
                                    <tr className="detail-row">
                                        <td className="detailLabel">Colour:</td>
                                        <td className="detailValue">{pets.colour || "Unknown"}</td>
                                    </tr>
                                    <tr className="detail-row">
                                        <td className="detailLabel">Gender:</td>
                                        <td className="detailValue">{pets.gender || "Unknown"}</td>
                                    </tr>
                                    <tr className="detail-row">
                                        <td className="detailLabel">Age:</td>
                                        <td className="detailValue">{pets.age || "Unknown"}</td>
                                    </tr>
                                    <tr className="detail-row">
                                        <td className="detailLabel">Size:</td>
                                        <td className="detailValue">{pets.size || "Unknown"}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="shelterInfo">
                                <h5 className="shelterName">{shelter.shelterName}</h5>
                                <p className="shelterAddress">{shelter.address}</p>
                                <div className="shelterBtn">
                                    <a href={`tel:${shelter.phoneNumber}`}>
                                        <CIcon icon={cilPhone} size="xxl" style={{ transform: "scaleX(-1)", color: "#70d2ff" }} />
                                    </a>
                                    <a href={`https://www.google.com/maps?q=${shelter.address}`} target="_blank" rel="noopener noreferrer">
                                        <CIcon icon={cilLocationPin} size="xxl" style={{ color: "#70d2ff" }} />
                                    </a>
                                </div>
                            </div>
                            <button className="applyAdoptBtn" onClick={adoptBtn}>Adopt Now</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    )
}

export default PetDetails;